import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "bg-black rounded-xs p-2 overflow-x-auto",
  ref: "pre"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("pre", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ], 512 /* NEED_PATCH */))
}